import {FeatureFlagType} from './enum/FeatureFlagType'
import {PolicyLimitType} from './enum/PolicyLimitType'
import {UsageType} from './enum/UsageType'
import {PlanFeatureType} from './enum/PlanFeatureType'
import {IPlanFeature} from './types/IPlanFeature'
import {createDefaultWorkspacePolicyLimits, createDefaultWorkspaceUsageLimits} from '../WorkspaceModel/workspaceDefaultEntitlements'

export interface IWorkspaceEntitlements {
  enabledFeatureFlagTypes: FeatureFlagType[]
  usageLimits: Record<UsageType, number>
  policyLimits: Record<PolicyLimitType, number>
}

export function deriveWorkspaceEntitlementsFromPlanFeatures(planFeatures: IPlanFeature[]): IWorkspaceEntitlements {
  const usageLimits = createDefaultWorkspaceUsageLimits()
  const policyLimits = createDefaultWorkspacePolicyLimits()
  const featureFlagState = new Map<FeatureFlagType, boolean>()
  for (const f of planFeatures) {
    if (f.planFeatureType === PlanFeatureType.IncludedUsageLimit) {
      usageLimits[f.payload.usageType] = f.payload.quantity
    }
    if (f.planFeatureType === PlanFeatureType.PolicyLimit) {
      policyLimits[f.payload.policyLimitType] = f.payload.quantity
    }
    if (f.planFeatureType === PlanFeatureType.FeatureFlag) {
      featureFlagState.set(f.payload.featureFlagType, f.payload.isEnabled)
    }
  }
  const enabledFeatureFlagTypes = [...featureFlagState.entries()]
    .filter(([, isEnabled]) => isEnabled)
    .map(([featureFlagType]) => featureFlagType)
  return {
    enabledFeatureFlagTypes,
    usageLimits,
    policyLimits,
  }
}
